/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-03-27 04:09:19
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ChevronDownMinor } from '@shopify/polaris-icons';

import { RenderSelect2 } from 'src/components/views/common/render-select-2-v3';

type Props = WithI18nProps;
type State = {
  toggleDisplayValue: boolean
};

class SelectTag extends Component<Props, State> {
  state = {
    toggleDisplayValue: true
  };
  render() {
    const { toggleDisplayValue } = this.state;
    const { i18n, tagOptions, tag, excludedValues, onChangeTag } = this.props;

    if (toggleDisplayValue) {
      return (
        <div className="BC-Button_Select">
          <Button fullWidth onClick={this.toggleDisplay} icon={ChevronDownMinor}>
            {tag.tag.label || (
              <TextStyle variation="subdued">
                {i18n.translate(
                  'AdminHTML.FilterTree.Item.optionModal_GeneralTab_MultiLevelTag_TagDetails_TagItem1_Placeholder'
                )}
              </TextStyle>
            )}
          </Button>
        </div>
      );
    }

    return (
      <RenderSelect2
        component={RenderSelect2}
        options={tagOptions}
        placeholder={i18n.translate(
          'AdminHTML.FilterTree.Item.optionModal_GeneralTab_MultiLevelTag_TagDetails_TagItem1_Placeholder'
        )}
        value={tag.tag}
        type={'tags'}
        excludedValues={excludedValues}
        onChange={onChangeTag}
        autoOpen={true}
      />
    );
  }

  toggleDisplay = () => {
    const { toggleDisplayValue } = this.state;
    this.setState({ toggleDisplayValue: !toggleDisplayValue });
  };
}

export default withI18n()(SelectTag);
